export default __webpack_public_path__ + "static/media/thumbs-up.372bffd8.svg";